// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TerminalCountrySelector: MarkdocTagRegistration = {
  tag: 'terminal-country-custom-page-selector',
  component: 'TerminalCountrySelector',
  attributes: {
    compatibilityData: {
      type: Object,
      description: 'Terminal compatibility data from the terminal context',
      localizable: false,
    },
    countryNames: {
      type: Array,
      description: 'List of country codes and their full-form names',
      localizable: false,
    },
    fallbackCountry: {
      type: String,
      description:
        'The country to default the selector to if the pref is not set',
      localizable: false,
    },
  },
};
